import Actions from './actions';

const { change: changeLocation, replace: replaceLocation } = Actions;

export { changeLocation, replaceLocation };

export { default as urlLocationMiddleware } from './middlewares/urlLocationMiddleware';
